import { getFirestore, collection, query, where, getDocs } from 'firebase/firestore';
import app from './firebase';

const firestore = getFirestore(app);

const userCollection = collection(firestore, 'user');

function validateEmail(email: string): Promise<boolean> {
  const q = query(userCollection, where('email', '==', email.toLowerCase()));
  return getDocs(q)
    .then((docs) => !docs.empty)
    .catch((error) => {
      throw new Error(error.code);
    });
}

export default validateEmail;
